<template>
  <div class="container-status-list-view flex justify-between gap-10">
    <!-- コンテナ数 -->
    <div class="status-count container-count flex gap-1 items-center">
      <span class="aisea-text-14-300-black"> コンテナ数 </span>
      <span class="aisea-text-14-600-black">
        {{ counts.container_count }}
      </span>
    </div>
    <!-- 正常 -->
    <div class="status-count active-count flex gap-1 items-center">
      <div class="color-chip active" />
      <span class="aisea-text-14-300-black"> 正常 </span>
      <span class="aisea-text-14-600-black">
        {{ counts.active_count }}
      </span>
    </div>
    <div class="status-count alert-count flex gap-1 items-center">
      <!-- 異常 -->
      <div class="color-chip alert" />
      <span class="aisea-text-14-300-black"> 異常 </span>
      <span class="aisea-text-14-600-black">
        {{ counts.alert_count }}
      </span>
    </div>
    <div class="status-count power-off-count flex gap-1 items-center">
      <div class="color-chip power-off" />
      <!-- 非稼働 -->
      <span class="aisea-text-14-300-black"> 非稼働 </span>
      <span class="aisea-text-14-600-black">
        {{ counts.power_off_count }}
      </span>
    </div>
    <!-- 監視休止 -->
    <div class="status-count interlock-count flex gap-1 items-center">
      <div class="color-chip interlock" />
      <span class="aisea-text-14-300-black"> 監視休止 </span>
      <span class="aisea-text-14-600-black">
        {{ counts.interlock_count }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContainerStatusCountListView",
  props: {
    counts: {
      container_count: { type: Number },
      active_count: { type: Number },
      alert_count: { type: Number },
      interlock_count: { type: Number },
      power_off_count: { type: Number },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.container-status-list-view {
  .status-count {
    position: relative;
    &:not(:first-child) {
      &::after {
        content: "|";
        color: $aisea-mouse-gray;
        font-variant: normal;
        position: absolute;
        left: -1.25rem;
      }
    }
  }
  .color-chip {
    min-width: 15px;
    max-width: 15px;
    height: 15px;
    border-radius: 15px;
    margin-right: 0.2rem;
  }
  .active {
    background-color: $aisea-green;
    border: solid 2px lighten($aisea-green, 20%);
  }
  .alert {
    background-color: $aisea-pink;
    border: solid 2px lighten($aisea-pink, 10%);
  }
  .interlock {
    background-color: $aisea-mouse-gray;
    border: 2px solid rgba($aisea-mouse-gray, 0.5);
    background-clip: padding-box;
  }
  .power-off {
    background-color: $aisea-light-gray;
    border: 2px solid $aisea-mouse-gray;
  }
}
</style>